import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,[_c(VCol,{attrs:{"cols":"12","sm":"4","md":"3"}},[_c('sidebar-menu',{attrs:{"title":"Dashboards","items":_vm.dashboardPageSidebarMenuItems}})],1),_c(VCol,{attrs:{"cols":"12","sm":"8","md":"9"}},[_c(VSheet,{staticClass:"surface",attrs:{"min-height":"70vh","rounded":"lg"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }